import React, { useEffect, useState } from 'react';
import { message, Modal, Space, Button } from 'antd';
import { useLazyQuery, useReactiveVar } from '@apollo/client';

import { CONNECT_PIPEDRIVE, PERFORM_PIPEDRIVE_ACTIONS } from 'graphql/queries/integrationQueries';
import { getUserId, userVar } from 'graphql/cache';
import { DownloadingPDFModalIntegration } from 'pages/Proposal/components/Modals';
import { pipedriveActionPaths } from 'constants/index';

import Loader from 'components/Loader/Loader';
import utils from 'utils/utils';
import CloseIcon from 'components/Icons/CloseIcon';

const PipedriveWindow = ({ history }) => {
  const user = useReactiveVar(userVar);
  const { pathname } = history.location;
  const [, pipedriveAction] = pathname.match(/^\/?[^/]*\/[^/]*\/(.*)$/) || [];

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState('');
  const [actionError, setActionError] = useState('');

  const [connectPipedrive] = useLazyQuery(CONNECT_PIPEDRIVE, {
    variables: {
      code: utils.getQueryStringValue('code'),
    },
    skip: !getUserId() || !utils.getQueryStringValue('code'),
    fetchPolicy: 'network-only',
    onCompleted: () => {
      sessionStorage.removeItem('pipedriveConnected');
      message.success('Pipedrive Connected Successfully');
      history.push('/integration?pipedrive=connected');
      setLoading(false);
    },
    onError: (err) => {
      sessionStorage.removeItem('pipedriveConnected');
      message.error('Pipedrive Connect Failed');
      history.push('/integration?pipedrive=failed');
      setLoading(false);
    },
  });

  const [performPipedriveAction] = useLazyQuery(PERFORM_PIPEDRIVE_ACTIONS, {
    fetchPolicy: 'cache-and-network',
    variables: {
      pipedriveAction,
      pipedriveUserId: utils.getQueryStringValue('userId'),
      pipedriveProposalId: utils.getQueryStringValue('id'),
      pipedriveToken: utils.getQueryStringValue('token'),
      origin: window.location.origin,
    },
    onCompleted: ({ performPipedriveActions }) => {
      if (performPipedriveActions.pdfLink) {
        window.open(performPipedriveActions.pdfLink, '_self');
      }
      if (performPipedriveActions.pid) {
        history.push(`/d/${performPipedriveActions.pid}`);
      }
      if (performPipedriveActions.id) {
        history.push(`/pd/${performPipedriveActions.id}`);
      }
      setShowModal(pipedriveAction);
    },
    onError: (error) => {
      setShowModal(true);
      setActionError(error.message);
    },
  });

  useEffect(() => {
    const pipedriveCode = utils.getQueryStringValue('code');
    const pipedriveState = utils.getQueryStringValue('state');
    const pipedriveError = utils.getQueryStringValue('error');

    if (pipedriveError) {
      message.error('Pipedrive Connect Failed');
      history.push('/integration?pipedrive=failed');
      return;
    }

    if (!loading && pipedriveCode) {
      if (!user) {
        const redirectUrl = `/oauth/pipedrive?code=${pipedriveCode}&state=${pipedriveState}`;
        sessionStorage.setItem('redirect-url', redirectUrl);
        history.push(`/login?${redirectUrl}`);
      } else {
        connectPipedrive();
        setLoading(true);
      }
    } else if (
      pipedriveActionPaths.some((pipedriveActionPath) => pathname.includes(pipedriveActionPath))
    ) {
      performPipedriveAction();
    }
  }, [connectPipedrive, loading, history, user, performPipedriveAction, pathname, pipedriveAction]);

  return showModal ? (
    <Modal
      className="simple-info-modal"
      centered
      visible
      footer={null}
      closeIcon={<CloseIcon className="close-icon" onClick={window.close} />}>
      <h3 className="title">
        Proposal {pipedriveAction === 'trash' ? `Moved to trash` : pipedriveAction}{' '}
        {actionError ? 'Failed' : 'Successfully'}
      </h3>
      <div className="divider" />

      <p className="body">{actionError}</p>

      <div className="button-wrapper">
        <Space>
          <Button className="large-btn" type="primary" onClick={window.close}>
            Close
          </Button>
        </Space>
      </div>
    </Modal>
  ) : pipedriveAction === 'download' ? (
    <DownloadingPDFModalIntegration />
  ) : (
    <Loader />
  );
};

export default PipedriveWindow;
